export default "__VITE_PUBLIC_ASSET__35531c7d__"